import { periodSearch } from '../period/period.search';

/** Every tenant's usage over the chosen period. */
export const platformUsageSearch = periodSearch;
